import getCssProp from 'DOM/getCssProp';
import debounce from 'lodash.debounce';
import iconArrowRight from './icons/iconArrowRight';
import iconArrowLeft from './icons/iconArrowLeft';

const selectors = {
  cardList: '[data-info-card-list]',
};

const slickConfig = {
  arrows: true,
  dots: true,
  swipe: true,
  draggable: true,
  slidesToShow: 1,
  centerMode: false,
  variableWidth: true,
  nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button" style="">${iconArrowRight}</button>`,
  prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="">${iconArrowLeft}</button>`,
};

const infoCardView = {
  init: function () {
    this.carouselEnabled = false;
    this.cardList = document.querySelector(selectors.cardList);
    this.viewMode = this.getCurrentViewMode();
  },
  getCurrentViewMode: function () {
    return getCssProp(this.cardList, '--view-mode');
  },
  getCarouselState: function () {
    return this.carouselEnabled;
  },
  setCarouselState: function (bool) {
    this.carouselEnabled = bool;
  },
  enableCarousel: function () {
    this.carousel = $(selectors.cardList).slick(slickConfig);
    this.setCarouselState(true);
    this.cardList.classList.remove('container');
  },
  disableCarousel: function () {
    this.carousel.slick('unslick');
    this.setCarouselState(false);
    this.cardList.classList.add('container');
  },
};

const infoCardController = {
  init: function () {
    infoCardView.init();

    if (!infoCardView.cardList) return;

    if (infoCardView.viewMode === 'carousel' && !infoCardView.getCarouselState()) {
      infoCardView.enableCarousel();
    }

    this.handleCarouselToggle = this.handleCarouselToggle.bind(this);
    window.addEventListener('resize', debounce(this.handleCarouselToggle, 400));
  },
  handleCarouselToggle: function () {
    const carouselEnabled = infoCardView.getCarouselState();
    const viewMode = infoCardView.getCurrentViewMode();

    if (!carouselEnabled && viewMode === 'carousel') {
      infoCardView.enableCarousel();
    } else if (carouselEnabled && viewMode === 'grid') {
      infoCardView.disableCarousel();
    }
  },
};

infoCardController.init();
